import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import knowledgeApi from '@/lib/knowledge-api'

export interface Chunk {
  id: string
  content: string
  available: boolean
  docnm_kwd: string
  document_id: string
  image_id: string
  important_keywords: string | string[]
  positions: string[]
  questions?: string[]
}

export interface ChunksResponse {
  success: boolean
  chunks: Chunk[]
  total: number
  page: number
  page_size: number
  doc: any
}

export function useChunks(
  kbId: string, 
  documentId: string, 
  page: number = 1, 
  pageSize: number = 10,
  keywords?: string
) {
  return useQuery({
    queryKey: ['chunks', kbId, documentId, page, pageSize, keywords],
    queryFn: async () => {
      const params: any = {
        page,
        page_size: pageSize
      }
      if (keywords) {
        params.keywords = keywords
      }
      
      const response = await knowledgeApi.get(
        `/knowledge/${kbId}/documents/${documentId}/chunks/`,
        { params }
      )
      return response.data as ChunksResponse
    },
    enabled: !!kbId && !!documentId,
  })
}

export function useUpdateChunk(kbId: string, documentId: string) {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: async ({ chunkId, content, important_keywords }: { 
      chunkId: string
      content?: string
      important_keywords?: string
    }) => {
      const response = await knowledgeApi.put(
        `/knowledge/${kbId}/documents/${documentId}/chunks/${chunkId}/`,
        { content, important_keywords }
      )
      return response.data
    },
    onSuccess: () => {
      // Invalidate chunks list to show updated data
      queryClient.invalidateQueries({ queryKey: ['chunks', kbId, documentId] })
    },
  })
}
